<script setup lang="ts">
import { computed } from 'vue'
import { groupIndicatorCards, type IIndicatorCard } from '@/interfaces/entities/management'
import IndicatorCard from './IndicatorCard.vue'

const props = defineProps<{
  cards: IIndicatorCard[]
  compact?: boolean
}>()

const groups = computed(() => groupIndicatorCards(props.cards))
</script>

<template>
  <div class="space-y-4">
    <div v-for="group in groups" :key="group.label">
      <h4 class="mb-2 text-xs font-semibold uppercase tracking-wide text-slate-400">{{ group.label }}</h4>
      <div
        class="grid gap-2"
        :class="compact
          ? 'grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5'
          : 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5'">
        <IndicatorCard
          v-for="card in group.cards"
          :key="card.key"
          :label="card.label"
          :value="card.value"
          :unit="card.unit" />
      </div>
    </div>
  </div>
</template>
